import { useMemo } from 'react';

import BannerDynamic from '../BannerDynamic';
import { useApp } from '../../../context';
import { selectAds } from '../../../utils/advertising';

/**
 * The HOME_BANNER slot.
 *
 * This file used to be a hardcoded Katombora panel — a specific camp, a
 * specific Cloudinary image and the literal string `$780`, none of it data.
 * It also carried a dead `items` array of three destinations that the
 * component never read.
 *
 * It is now a sold placement. Nothing to show means nothing renders: unlike
 * the hero carousel, this section pins no height, so an unsold slot costs the
 * page a gap rather than a collapsed layout. Create a house advert in
 * /admin/advertising to fill it.
 */
export default function BannerSection() {
  const { adverts, serviceListing, listingsLoaded } = useApp();

  const listingsById = useMemo(() => {
    const map = {};
    (serviceListing || []).forEach((l) => { map[l.id] = l; });
    return map;
  }, [serviceListing]);

  const ad = useMemo(
    () => selectAds(adverts, 'HOME_BANNER', { listingsById, listingsLoaded })[0] || null,
    [adverts, listingsById, listingsLoaded]
  );

  return <BannerDynamic ad={ad} />;
}
